'use client'

import { MoonIcon, SunIcon } from 'lucide-react'
import { useTheme } from 'next-themes'
import { Button } from './ui/button'

export default function ThemeSwitcher() {
      const { theme, setTheme } = useTheme()

      return (
            <Button variant="ghost" size="icon"
                  className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
                  onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            >
                  {theme === 'dark' ? <SunIcon className="w-4 h-4" /> : <MoonIcon className="w-4 h-4" />}
            </Button>
      )
} 